export enum UserType {
  auditor = 'auditor',
  consultant = 'consultant',
  client = 'client'
}
